/* ============================================================
   Nateland — Tradable Bits opt-in bridge
   Routes an existing Shopify newsletter form through to the
   Tradable Bits CRM via the TBITS SDK (optInFan), instead of
   creating a Shopify customer.

   Activated per-form by a sibling marker element:
     <div data-tb-optin data-tb-key="..." data-tb-tag="..." data-tb-idol="..."></div>
   placed inside the same .footer-block__newsletter wrapper.
   ============================================================ */
(function () {
  'use strict';

  var SDK_SRC = 'https://tradablebits.com/tbits-sdk.js';
  var sdkPromise = null;

  function loadSDK() {
    if (window.TBITS) return Promise.resolve(window.TBITS);
    if (sdkPromise) return sdkPromise;
    sdkPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = SDK_SRC;
      s.async = true;
      s.onload = function () { window.TBITS ? resolve(window.TBITS) : reject(new Error('TBITS SDK loaded but global missing')); };
      s.onerror = function () { reject(new Error('Failed to load TBITS SDK')); };
      document.head.appendChild(s);
    });
    return sdkPromise;
  }

  function findForm(marker) {
    var scope = marker.closest('.footer-block__newsletter') || marker.parentElement || document;
    return scope.querySelector('form.newsletter-form') || scope.querySelector('form');
  }

  function setMessage(form, text, isError) {
    var box = form.querySelector('[data-tb-message]');
    if (!box) {
      box = document.createElement('p');
      box.setAttribute('data-tb-message', '');
      box.className = 'newsletter-form__message form__message';
      box.setAttribute('role', 'status');
      box.setAttribute('aria-live', 'polite');
      form.appendChild(box);
    }
    box.textContent = text;
    box.style.color = isError ? '#d02b20' : '';
    box.hidden = false;
  }

  function bind(marker) {
    if (marker.dataset.tbBound) return;
    var form = findForm(marker);
    if (!form) return;
    marker.dataset.tbBound = '1';

    var cfg = {
      key: marker.dataset.tbKey || '',
      tag: marker.dataset.tbTag || '',
      idol: marker.dataset.tbIdol || ''
    };
    if (!cfg.key) return; // nothing to route to

    // Warm up the SDK early so the first submit is fast.
    loadSDK().catch(function () {});

    form.addEventListener('submit', function (e) {
      var emailInput = form.querySelector('input[type="email"], input[name="contact[email]"]');
      var email = emailInput ? emailInput.value.trim() : '';
      if (!email) return; // let native validation handle empties

      // Route to Tradable Bits instead of Shopify's customer endpoint.
      e.preventDefault();
      e.stopImmediatePropagation();

      var btn = form.querySelector('button[type="submit"], [name="commit"]');
      if (btn) btn.disabled = true;

      loadSDK().then(function (TBITS) {
        TBITS.init(cfg.key);
        return TBITS.optInFan({
          email: email,
          is_subscribed: true,
          tag_name: cfg.tag,
          idol_name: cfg.idol
        });
      }).then(function () {
        setMessage(form, 'Thanks — you’re signed up!', false);
        if (emailInput) emailInput.value = '';
      }).catch(function (err) {
        setMessage(form, 'Something went wrong. Please try again.', true);
        if (window.console) console.error('[TB opt-in]', err);
      }).then(function () {
        if (btn) btn.disabled = false;
      });
    }, true); // capture phase: run before any theme submit handlers
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-tb-optin]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // Shopify editor: re-bind when the footer section reloads.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
